export enum classNames {
    XAPP_SEARCH_BUTTON = "xapp-search-button"
}
